/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ twitterHandle: NonNullable<unknown> }} Get_Listed_Dialog_Tweet_Chain_Text_Community_MemberInputs */



/**
* | output |
* | --- |
* | "Hey @{twitterHandle} 👋 Would love to see you listed on @chainspect_app! Your fundamental metrics deserve visibility, make it happen 💪" |
*
* @param {Get_Listed_Dialog_Tweet_Chain_Text_Community_MemberInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const get_listed_dialog_tweet_chain_text_community_member = /** @type {((inputs: Get_Listed_Dialog_Tweet_Chain_Text_Community_MemberInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Get_Listed_Dialog_Tweet_Chain_Text_Community_MemberInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`Hey @${i?.twitterHandle} 👋 Would love to see you listed on @chainspect_app! Your fundamental metrics deserve visibility, make it happen 💪`)
});